import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import classnames from 'classnames';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faAngleRight from '@fortawesome/fontawesome-free-solid/faAngleRight';
// import faAngleDown from '@fortawesome/fontawesome-free-solid/faAngleDown';
import faCaretSquareRight from '@fortawesome/fontawesome-free-solid/faCaretSquareRight';
import faCaretSquareDown from '@fortawesome/fontawesome-free-solid/faCaretSquareDown';
import { getItemById } from '../lib/util';

const animationName = 'animation';
const animationTime = {
  enter: 500,
  exit: 500,
};

const CatalogSidebarItem = (props) => {
  const {
    data, categories, parentPath, level, location,
  } = props;
  const toggleMobileModal = props.toggleMobileModal || null;
  const currPath = `${parentPath}/${data.id}`;

  const category = getItemById({
    id: data.id,
    array: categories,
    key: 'category_ID',
  });

  const isActiveRegex = new RegExp(`${currPath.replace(/\//g, '\\/')}($|\\/)`);
  const isActive = location.pathname.match(isActiveRegex);
  const hasChildren = data.children.length > 0;

  const itemClassName = classnames({
    'sidebar-item': true,
    [`menu-level-${level}`]: true,
    'is-active': isActive,
  });

  const CSSTransitionProps = {
    timeout: animationTime,
    classNames: animationName,
  };

  return (
    <TransitionGroup className={itemClassName} key={data.id} component="li" appear>
      <CSSTransition {...CSSTransitionProps}>
        <Link
          to={currPath}
          onClick={() => {
            if (level >= 2) {
              toggleMobileModal();
            }
          }}
        >
          <span className="icon">
            {/* hasChildren && (
              <FontAwesomeIcon icon={isActive ? faCaretSquareDown : faCaretSquareRight} size="xs" />
            ) */}
            <FontAwesomeIcon icon={hasChildren ? isActive ? faCaretSquareDown : faCaretSquareRight : faAngleRight} size="xs" />
          </span>

          <span className="text">{category.title}</span>
        </Link>
      </CSSTransition>
      {isActive &&
        hasChildren && (
          <CSSTransition {...CSSTransitionProps}>
            <ul className="sub-menu-list">
              {data.children.map((child, index) => (
                <CatalogSidebarItem
                  key={index}
                  data={child}
                  level={level + 1}
                  parentPath={currPath}
                  categories={categories}
                  location={location}
                  toggleMobileModal={toggleMobileModal}
                />
              ))}
            </ul>
          </CSSTransition>
        )}
    </TransitionGroup>
  );
};

CatalogSidebarItem.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.object).isRequired,
  data: PropTypes.shape({}).isRequired,
  parentPath: PropTypes.string.isRequired,
  level: PropTypes.number.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  toggleMobileModal: PropTypes.func,
};

CatalogSidebarItem.defaultProps = {
  location: {
    pathname: '/catalog',
  },
  toggleMobileModal: () => {},
};

export default CatalogSidebarItem;



// WEBPACK FOOTER //
// ./src/components/CatalogSidebarItem.js